<script lang="ts" src="./ManufyValueListModal.ts"/>

<template>
  <div v-if="flags.show" class="modal viewport-scroll" @click.self="hide()">
    <div class="modal-dialog w-medium secondary">

      <div class="dialog-header">
        <h2 class="title">
          {{ $trans.t('app.labels.manufyValues') }}
        </h2>

        <a class="close" href="#" @click.prevent="hide()">
          <m-icon :solid="true" :type="$const.IconTypes.FONT_AWESOME" name="xmark"/>
        </a>
      </div>

      <div class="dialog-body">
        <div v-if="values.length > 0" class="mb-3">
          <m-value-pill
            v-for="value in values"
            :appearance="$const.StyleAppearance.PRIMARY"
            :icon="value"
            :size="$const.StyleSize.XSMALL"
            class="mr-2 mb-2"
          >
            {{ $trans.t('meta.manufyValues.' + value) }}
          </m-value-pill>
        </div>
      </div>

    </div>
  </div>

</template>
